import React, {ReactElement, useContext} from 'react';
import {OnboardingContext, OnboardingContextType} from 'src/components/Onboarding/context';
import {FormikContextType, FormikHelpers, useFormikContext} from 'formik';
import {isEmpty} from 'lodash';
import RegistrationFooterBase from 'shared/components/footer-with-steps';
import {StepPosition} from 'src/types/form';

// eslint-disable-next-line -- TODO: fix Actions unused
export type OnboardingFooterProps<FormValues, Actions> = {
  stepCount: number;
  stepPosition: StepPosition;
  onBack: (formikHelpers: FormikHelpers<FormValues>) => Promise<void> | void;
  onControlledSubmit: (
    form: FormikContextType<FormValues>,
    stepPosition: StepPosition
  ) => Promise<void>;
};

export default function OnboardingFooter<FormValues, Actions>(
  props: OnboardingFooterProps<FormValues, Actions>
): ReactElement {
  const {primaryButton, canSubmit, isLoading, isControlledStep} =
    useContext<OnboardingContextType>(OnboardingContext);
  const form = useFormikContext<FormValues>();
  const onControlledSubmit = (): void => {
    props.onControlledSubmit(form, props.stepPosition);
  };

  const onBack =
    props.stepPosition.index > 0
      ? (): void => {
          props.onBack(form);
        }
      : null;

  const primaryDisabled = primaryButton.controlled
    ? primaryButton.disabled
    : form.isSubmitting || !isEmpty(form.errors);

  return (
    <RegistrationFooterBase
      backDisabled={props.stepPosition.index === 0}
      currentStepIndex={props.stepPosition.index}
      numberOfSteps={props.stepCount}
      onBack={onBack}
      onNext={isControlledStep ? onControlledSubmit : null}
      primaryActionDisabled={primaryDisabled}
      primaryActionLoading={form.isSubmitting || isLoading}
      primaryColor={primaryButton.color}
      primaryText={canSubmit && primaryButton.color !== 'red' ? 'Finish' : primaryButton.text}
    />
  );
}
